import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

interface BetaBannerProps {
  onFeedbackClick: () => void;
}

const BetaBanner: React.FC<BetaBannerProps> = ({ onFeedbackClick }) => {
  const [visible, setVisible] = useState(() => !localStorage.getItem('betaBannerDismissed'));
  const isMobile = useMediaQuery('(max-width: 640px)');
  const bannerHeight = isMobile ? '52px' : '44px';

  useEffect(() => {
    document.documentElement.style.setProperty('--banner-height', visible ? bannerHeight : '0px');
    return () => { document.documentElement.style.setProperty('--banner-height', '0px'); };
  }, [visible, bannerHeight]);

  if (!visible) return null;

  const handleDismiss = () => {
    localStorage.setItem('betaBannerDismissed', 'true');
    setVisible(false);
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, height: bannerHeight,
      background: '#1a1a2e', color: '#fff', zIndex: 1100,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: isMobile ? '0.78rem' : '0.82rem',
      fontFamily: "'Montserrat', sans-serif",
      gap: isMobile ? 6 : 10,
      padding: isMobile ? '0 36px' : '0 48px',
    }}>
      <span style={{ whiteSpace: 'nowrap' }}>
        🚀 {isMobile ? 'We\'re in Beta!' : 'We\'re in Beta — found a bug or have a suggestion?'}
      </span>
      <span
        onClick={onFeedbackClick}
        style={{ cursor: 'pointer', textDecoration: 'underline', whiteSpace: 'nowrap' }}
      >
        {isMobile ? 'Feedback →' : 'Tell us →'}
      </span>
      {!isMobile && (
        <>
          <span style={{ opacity: 0.5 }}>·</span>
          <Link to="/help" style={{ color: '#fff', textDecoration: 'underline', whiteSpace: 'nowrap' }}>
            Check our Help page →
          </Link>
        </>
      )}
      <button
        onClick={handleDismiss}
        aria-label="Dismiss banner"
        style={{
          position: 'absolute', right: 10,
          background: 'none', border: 'none', color: '#fff',
          cursor: 'pointer', fontSize: '1rem', lineHeight: 1, padding: 4,
          opacity: 0.7,
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default BetaBanner;
